/* Copyright (c) 2020-present CloudIO Inc */

import {
  atom,
  Key,
  selector,
  StateXGetter,
  StateXQuiteSetter,
} from '@cloudio-saas/statex';

const localStorageAtom = atom<unknown>({
  path: ['localStorage', ':appUid', ':key'],
  defaultValue: null,
  onChange: ({ getOnce, path }) => {
    const appUid = path[1];
    const appData = getOnce(appLocalStorageAtom, {
      params: { appUid },
    });
    localStorage?.setItem(`_io_${appUid}`, JSON.stringify(appData ?? {}));
  },
});

const appLocalStorageAtom = atom<Record<string, unknown> | null>({
  path: ['localStorage', ':appUid'],
  defaultValue: null,
});

function ensureAppLocalStorageData({
  params,
  set,
  getOnce,
}: {
  params: Record<string, Key>;
  set: StateXQuiteSetter;
  getOnce: StateXGetter;
}): void {
  if (!localStorage) {
    console.warn('Missing localStorage!');
    return;
  }
  let appData = getOnce(appLocalStorageAtom, { params });
  if (appData === null && localStorage) {
    const val = localStorage.getItem(`_io_${params.appUid}`) ?? '{}';
    appData = JSON.parse(val);
    set(appLocalStorageAtom, appData, { params });
  }
}

export const localStorageSelector = selector<unknown>({
  path: ['localStorage', ':appUid', ':key'],
  get: ({ get, params, getOnce, setQuietly }) => {
    ensureAppLocalStorageData({ set: setQuietly, getOnce, params });
    return get(localStorageAtom, { params });
  },
  set: ({ set, setQuietly, params, getOnce }, value) => {
    ensureAppLocalStorageData({ set: setQuietly, getOnce, params });
    set(localStorageAtom, value, { params });
  },
});
